// extracted by mini-css-extract-plugin
export default {"transaction-item":"transaction_transaction-item__Ic5OQ","expense":"transaction_expense__KWYv4","left":"transaction_left__kmg7+"};